/* Shared phone + country components.
   PHONE_COUNTRIES is the canonical list (also feeds the address-country
   dropdown). PhoneField renders the 3-part input (flag+dial dropdown,
   area, local). CountrySelect renders the country-of-address dropdown
   (flag + name). MX/US/CA are pinned to the top of both. */
import React from "react";
import SearchSelect from "./SearchSelect";

export const PHONE_COUNTRIES = [
  { code: "MX", flag: "🇲🇽", dial: "+52", nameEn: "Mexico", nameEs: "México" },
  { code: "US", flag: "🇺🇸", dial: "+1", nameEn: "United States", nameEs: "Estados Unidos" },
  { code: "CA", flag: "🇨🇦", dial: "+1", nameEn: "Canada", nameEs: "Canadá" },
  { code: "AR", flag: "🇦🇷", dial: "+54", nameEn: "Argentina", nameEs: "Argentina" },
  { code: "AU", flag: "🇦🇺", dial: "+61", nameEn: "Australia", nameEs: "Australia" },
  { code: "AT", flag: "🇦🇹", dial: "+43", nameEn: "Austria", nameEs: "Austria" },
  { code: "BE", flag: "🇧🇪", dial: "+32", nameEn: "Belgium", nameEs: "Bélgica" },
  { code: "BZ", flag: "🇧🇿", dial: "+501", nameEn: "Belize", nameEs: "Belice" },
  { code: "BO", flag: "🇧🇴", dial: "+591", nameEn: "Bolivia", nameEs: "Bolivia" },
  { code: "BR", flag: "🇧🇷", dial: "+55", nameEn: "Brazil", nameEs: "Brasil" },
  { code: "CL", flag: "🇨🇱", dial: "+56", nameEn: "Chile", nameEs: "Chile" },
  { code: "CN", flag: "🇨🇳", dial: "+86", nameEn: "China", nameEs: "China" },
  { code: "CO", flag: "🇨🇴", dial: "+57", nameEn: "Colombia", nameEs: "Colombia" },
  { code: "CR", flag: "🇨🇷", dial: "+506", nameEn: "Costa Rica", nameEs: "Costa Rica" },
  { code: "CU", flag: "🇨🇺", dial: "+53", nameEn: "Cuba", nameEs: "Cuba" },
  { code: "CZ", flag: "🇨🇿", dial: "+420", nameEn: "Czech Republic", nameEs: "República Checa" },
  { code: "DK", flag: "🇩🇰", dial: "+45", nameEn: "Denmark", nameEs: "Dinamarca" },
  { code: "DO", flag: "🇩🇴", dial: "+1", nameEn: "Dominican Republic", nameEs: "República Dominicana" },
  { code: "EC", flag: "🇪🇨", dial: "+593", nameEn: "Ecuador", nameEs: "Ecuador" },
  { code: "EG", flag: "🇪🇬", dial: "+20", nameEn: "Egypt", nameEs: "Egipto" },
  { code: "SV", flag: "🇸🇻", dial: "+503", nameEn: "El Salvador", nameEs: "El Salvador" },
  { code: "FI", flag: "🇫🇮", dial: "+358", nameEn: "Finland", nameEs: "Finlandia" },
  { code: "FR", flag: "🇫🇷", dial: "+33", nameEn: "France", nameEs: "Francia" },
  { code: "DE", flag: "🇩🇪", dial: "+49", nameEn: "Germany", nameEs: "Alemania" },
  { code: "GR", flag: "🇬🇷", dial: "+30", nameEn: "Greece", nameEs: "Grecia" },
  { code: "GT", flag: "🇬🇹", dial: "+502", nameEn: "Guatemala", nameEs: "Guatemala" },
  { code: "HT", flag: "🇭🇹", dial: "+509", nameEn: "Haiti", nameEs: "Haití" },
  { code: "HN", flag: "🇭🇳", dial: "+504", nameEn: "Honduras", nameEs: "Honduras" },
  { code: "HU", flag: "🇭🇺", dial: "+36", nameEn: "Hungary", nameEs: "Hungría" },
  { code: "IN", flag: "🇮🇳", dial: "+91", nameEn: "India", nameEs: "India" },
  { code: "ID", flag: "🇮🇩", dial: "+62", nameEn: "Indonesia", nameEs: "Indonesia" },
  { code: "IE", flag: "🇮🇪", dial: "+353", nameEn: "Ireland", nameEs: "Irlanda" },
  { code: "IT", flag: "🇮🇹", dial: "+39", nameEn: "Italy", nameEs: "Italia" },
  { code: "JM", flag: "🇯🇲", dial: "+1", nameEn: "Jamaica", nameEs: "Jamaica" },
  { code: "JP", flag: "🇯🇵", dial: "+81", nameEn: "Japan", nameEs: "Japón" },
  { code: "MA", flag: "🇲🇦", dial: "+212", nameEn: "Morocco", nameEs: "Marruecos" },
  { code: "NL", flag: "🇳🇱", dial: "+31", nameEn: "Netherlands", nameEs: "Países Bajos" },
  { code: "NZ", flag: "🇳🇿", dial: "+64", nameEn: "New Zealand", nameEs: "Nueva Zelanda" },
  { code: "NI", flag: "🇳🇮", dial: "+505", nameEn: "Nicaragua", nameEs: "Nicaragua" },
  { code: "NG", flag: "🇳🇬", dial: "+234", nameEn: "Nigeria", nameEs: "Nigeria" },
  { code: "NO", flag: "🇳🇴", dial: "+47", nameEn: "Norway", nameEs: "Noruega" },
  { code: "PK", flag: "🇵🇰", dial: "+92", nameEn: "Pakistan", nameEs: "Pakistán" },
  { code: "PA", flag: "🇵🇦", dial: "+507", nameEn: "Panama", nameEs: "Panamá" },
  { code: "PY", flag: "🇵🇾", dial: "+595", nameEn: "Paraguay", nameEs: "Paraguay" },
  { code: "PE", flag: "🇵🇪", dial: "+51", nameEn: "Peru", nameEs: "Perú" },
  { code: "PH", flag: "🇵🇭", dial: "+63", nameEn: "Philippines", nameEs: "Filipinas" },
  { code: "PL", flag: "🇵🇱", dial: "+48", nameEn: "Poland", nameEs: "Polonia" },
  { code: "PT", flag: "🇵🇹", dial: "+351", nameEn: "Portugal", nameEs: "Portugal" },
  { code: "PR", flag: "🇵🇷", dial: "+1", nameEn: "Puerto Rico", nameEs: "Puerto Rico" },
  { code: "RO", flag: "🇷🇴", dial: "+40", nameEn: "Romania", nameEs: "Rumania" },
  { code: "RU", flag: "🇷🇺", dial: "+7", nameEn: "Russia", nameEs: "Rusia" },
  { code: "SA", flag: "🇸🇦", dial: "+966", nameEn: "Saudi Arabia", nameEs: "Arabia Saudita" },
  { code: "SG", flag: "🇸🇬", dial: "+65", nameEn: "Singapore", nameEs: "Singapur" },
  { code: "ZA", flag: "🇿🇦", dial: "+27", nameEn: "South Africa", nameEs: "Sudáfrica" },
  { code: "KR", flag: "🇰🇷", dial: "+82", nameEn: "South Korea", nameEs: "Corea del Sur" },
  { code: "ES", flag: "🇪🇸", dial: "+34", nameEn: "Spain", nameEs: "España" },
  { code: "SE", flag: "🇸🇪", dial: "+46", nameEn: "Sweden", nameEs: "Suecia" },
  { code: "CH", flag: "🇨🇭", dial: "+41", nameEn: "Switzerland", nameEs: "Suiza" },
  { code: "TH", flag: "🇹🇭", dial: "+66", nameEn: "Thailand", nameEs: "Tailandia" },
  { code: "TT", flag: "🇹🇹", dial: "+1", nameEn: "Trinidad and Tobago", nameEs: "Trinidad y Tobago" },
  { code: "TR", flag: "🇹🇷", dial: "+90", nameEn: "Turkey", nameEs: "Turquía" },
  { code: "UA", flag: "🇺🇦", dial: "+380", nameEn: "Ukraine", nameEs: "Ucrania" },
  { code: "AE", flag: "🇦🇪", dial: "+971", nameEn: "United Arab Emirates", nameEs: "Emiratos Árabes Unidos" },
  { code: "GB", flag: "🇬🇧", dial: "+44", nameEn: "United Kingdom", nameEs: "Reino Unido" },
  { code: "UY", flag: "🇺🇾", dial: "+598", nameEn: "Uruguay", nameEs: "Uruguay" },
  { code: "VE", flag: "🇻🇪", dial: "+58", nameEn: "Venezuela", nameEs: "Venezuela" },
  { code: "VN", flag: "🇻🇳", dial: "+84", nameEn: "Vietnam", nameEs: "Vietnam" },
];

const PINNED = ["MX", "US", "CA"];

function orderedCountries(lang) {
  var top = PINNED.map(function (k) { return PHONE_COUNTRIES.find(function (c) { return c.code === k; }); }).filter(Boolean);
  var rest = PHONE_COUNTRIES.filter(function (c) { return PINNED.indexOf(c.code) < 0; });
  rest.sort(function (a, b) {
    var an = lang === "es" ? a.nameEs : a.nameEn;
    var bn = lang === "es" ? b.nameEs : b.nameEn;
    return an.localeCompare(bn);
  });
  return top.concat(rest);
}

/* Phone dial options — label is flag + dial code (compact in trigger). */
export function buildPhoneCountryOptions(lang) {
  return orderedCountries(lang).map(function (c) {
    return {
      value: c.code,
      label: c.flag + " " + c.dial,
      search: c.nameEn + " " + c.nameEs + " " + c.code + " " + c.dial,
    };
  });
}

/* Address-country options — label is flag + name. Stored as full
   English country name (matches legacy data like "Mexico", "USA"). */
export function buildCountryOptions(lang) {
  return orderedCountries(lang).map(function (c) {
    return {
      value: c.nameEn,
      label: c.flag + " " + (lang === "es" ? c.nameEs : c.nameEn),
      search: c.nameEn + " " + c.nameEs + " " + c.code,
    };
  });
}

export function parsePhone(s) {
  var str = String(s == null ? "" : s).trim();
  if (!str) return { country: "MX", area: "", local: "" };
  var m = str.match(/^(\+\d{1,4})(.*)$/);
  if (!m) return { country: "MX", area: "", local: str };
  var dial = m[1];
  var country = (PHONE_COUNTRIES.find(function (c) { return c.dial === dial; }) || { code: "MX" }).code;
  var rest = m[2];
  /* Strip a single leading separator (dash or space) but PRESERVE the
     rest, including empty segments. The previous .split(/[\s-]+/) +
     .filter(Boolean) collapsed empty segments — so "+52-1" (area only)
     and "+52-1" (local only) became indistinguishable, and the first
     digit typed into the Area input always reflected back as Local
     (parsed as a single segment, defaulted to local). Now we keep the
     dash-delimited structure intact and treat the substring before the
     first dash as the area code. */
  if (rest.length > 0 && (rest.charAt(0) === "-" || rest.charAt(0) === " ")) {
    rest = rest.slice(1);
  }
  var dashIdx = rest.indexOf("-");
  if (dashIdx >= 0) {
    return {
      country: country,
      area: rest.slice(0, dashIdx).replace(/\D/g, ""),
      local: rest.slice(dashIdx + 1),
    };
  }
  /* No dash means a single segment. Backwards-compat heuristic for
     legacy data that never went through the new serializer: short
     numeric (≤3 digits) → area, longer → local. */
  if (rest.length <= 3 && /^\d*$/.test(rest)) {
    return { country: country, area: rest, local: "" };
  }
  return { country: country, area: "", local: rest };
}

export function formatPhoneLocal(s) {
  var digits = String(s == null ? "" : s).replace(/\D/g, "").slice(0, 7);
  if (digits.length <= 3) return digits;
  return digits.slice(0, 3) + "-" + digits.slice(3);
}

export function serializePhone(country, area, local) {
  var c = PHONE_COUNTRIES.find(function (x) { return x.code === country; }) || PHONE_COUNTRIES[0];
  var a = String(area || "").replace(/\D/g, "").slice(0, 3);
  var l = formatPhoneLocal(local);
  if (!a && !l) return "";
  /* ALWAYS emit dial-area-local with explicit (possibly empty) area
     and local segments so parsePhone can disambiguate
     "area only" from "local only". Without this the round-trip
     re-parses "+52-1" as { area: "", local: "1" } and the first
     digit typed into Area jumps to the Local input. */
  return c.dial + "-" + a + "-" + l;
}

/* PhoneField — 3-part input matching the Carrier Info pattern.
   `value` is the serialized "+DIAL-AREA-000-0000" string and `onChange`
   gets the new serialized string. Style overrides are merged into the
   inner inputs (background, error border, etc.). */
export function PhoneField({ value, onChange, lang, inputStyle, disabled, areaPlaceholder, localPlaceholder, width, country }) {
  var parsed = parsePhone(value || "");
  /* When the caller passes an explicit `country` prop it takes
     precedence for DISPLAY over the country derived from the
     serialized value. This fixes the case where the phone number is
     empty (serialized value === "") so parsePhone falls back to MX
     even though the parent already knows the chosen country. */
  if (country) parsed = Object.assign({}, parsed, { country: country });
  var opts = buildPhoneCountryOptions(lang);
  var commit = function (country, area, local) { onChange(serializePhone(country, area, local), country); };
  var inp = inputStyle || { padding: "6px 8px", borderRadius: 6, border: "1px solid var(--color-border)", background: "var(--color-bg-input)", color: "var(--color-text)", fontSize: 12 };
  return (
    <div style={{ display: "flex", gap: 4, width: width || "100%" }}>
      <div style={{ width: 110, flexShrink: 0 }}>
        <SearchSelect
          value={parsed.country}
          onChange={function (v) { commit(v, parsed.area, parsed.local); }}
          options={opts}
          placeholder="—"
          disabled={disabled}
          style={{ background: inp.background }}
        />
      </div>
      <input
        value={parsed.area}
        onChange={function (e) { commit(parsed.country, e.target.value.replace(/\D/g, "").slice(0, 3), parsed.local); }}
        placeholder={areaPlaceholder || (lang === "es" ? "Área" : "Area")}
        maxLength={3}
        disabled={disabled}
        inputMode="numeric"
        style={Object.assign({}, inp, { width: 60, textAlign: "center", fontFamily: "'JetBrains Mono', monospace" })}
      />
      <input
        value={parsed.local}
        onChange={function (e) { commit(parsed.country, parsed.area, e.target.value); }}
        placeholder={localPlaceholder || "000-0000"}
        maxLength={8}
        disabled={disabled}
        inputMode="numeric"
        style={Object.assign({}, inp, { flex: 1, fontFamily: "'JetBrains Mono', monospace" })}
      />
    </div>
  );
}

/* CountrySelect — single dropdown for address country.
   `value` is the country English name (matches legacy storage). */
export function CountrySelect({ value, onChange, lang, disabled, style, placeholder }) {
  return (
    <SearchSelect
      value={value || ""}
      onChange={onChange}
      options={buildCountryOptions(lang)}
      placeholder={placeholder || (lang === "es" ? "País" : "Country")}
      disabled={disabled}
      style={style}
    />
  );
}
